<template>
    <div class="program-admin-invite page-invite">
        <data-form title="Invite Program Admin"
                   tag="program-admin-invite"
                   save-button-label="Send"
                   :field-model="fieldModel"
                   :field-groups="fieldGroups"
                   :on-submit-handler="onSubmit"
                   submit-success-message="Invite sent"
                   submit-error-message="Error inviting user"
                   :submit-success-route="'/'">
        </data-form>
    </div>
</template>

<script>
import { required, email as emailValidator } from 'vuelidate/lib/validators'
import Agency from '@/models/Agency'
import Validation from "@/providers/Validation";

export default {
    name: 'ProgramAdminInvite',
    data () {
        return {
            fieldModel: {
                fields: {
                    email: {
                        label: 'Email',
                        type: 'text',
                        validations: {
                            required,
                            email: v => v ? emailValidator(v.toLowerCase()) : true,
                            email_unique: Validation.validateEmailUnique
                        },
                        invalidFeedback: {
                            email_unique: 'This email is already a user in The Yard!'
                        }
                    },
                    agency_id: {
                        label: 'Agency',
                        type: 'select',
                        options: [],
                        async loadOptions () {
                            Agency.loadAgencyOptions(this)
                        },
                        validations: { required }
                    },
                }
            },
            fieldGroups: [['email', 'agency_id']],
        }
    },
    methods: {
        onSubmit (modelInstance) {
            return this.$api.inviteProgramAdmin(this, modelInstance)
        }
    }
}
</script>
